import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '@redux-actions/';

import { mapClData } from '@utils/pages-utils/ContactsUtils';
import { getContactsPrescriptions } from '@services/contactsServices';
import useLoginState from '@hooks/useLoginState';
import LoggedUserPage from '@pages/ContactLensesPDPPrescriptions/LoggedUserPage';
import GuestUserPage from '@pages/ContactLensesPDPPrescriptions/GuestUserPage';
import { Config } from '@interfaces/mainInterfaces';
import LoaderElement from '@loaders/LoaderElement';

interface Props {
    config: Config;
}

const App = ({ config }: Props) => {
    const dispatch = useDispatch();
    const { isLoggedIn } = useLoginState();

    // check whether the user is logged in or not
    useEffect(() => {
        try {
            if (!!config?.isLoggedIn) {
                console.log('calling isLoggedIn');
                Promise.resolve(config?.isLoggedIn()).then(result => {
                    dispatch(actions.setIsLoggedIn(result));
                });
            } else {
                console.warn('missing config.isLoggedIn!');
            }
        } catch (err) {
            console.error(err);
        }
    }, []);

    // save the config and CL data globally
    useEffect(() => {
        dispatch(actions.saveConfig(config));
        dispatch(actions.saveContactLensesData(mapClData(config.currentProduct)));
    }, []);

    // if the user is logged in get their CL prescriptions
    useEffect(() => {
        if (isLoggedIn === 'LOGGED') {
            dispatch(
                getContactsPrescriptions({
                    isMockRequest: config.mockRequest,
                    storeId: config.storeId,
                    catalogId: config.catalogId,
                    productId: config.productId,
                })
            );
        }
    }, [isLoggedIn]);

    return (
        <div id="lc-contacts-pdp">
            {isLoggedIn === 'LOADING' && <LoaderElement height={200} />}
            {isLoggedIn === 'LOGGED' && <LoggedUserPage />}
            {isLoggedIn === 'NOT_LOGGED' && <GuestUserPage />}
        </div>
    );
};

export default App;
